<template>
	<div>
		<div class="sense-main">
			<div class="sense-breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				    <el-breadcrumb-item :to="{ path: backPath }">{{ name }}</el-breadcrumb-item>
				    <el-breadcrumb-item>消息详情</el-breadcrumb-item>
				</el-breadcrumb>
			</div>			
			<div class="sense-table-list sense-table-ellipsis sense-detail">
				<div class="sense-notice-detail">
					<div class="sense-notice-detail-con">
						<h3 class="clearfix">
							<b class="sense-ellipsis fl">{{ messageDetailObj.title }}</b>
							<span class="fr">{{ messageDetailObj.createAt }}</span>
						</h3>					
						<p v-html="messageDetailObj.text"></p>
					</div>									
				</div>
			</div>
		</div>
		<div class="all-dialog">
			
		</div>
	</div>
</template>

<script>
	import { ajax } from '../api/api.js'

	export default {
		data() {
			return {
				noticeGuid: '',
				name: '',
				backPath: '',
				messageDetailObj: {},	
			}
		},
		methods: {
			loadDetailData() {	
				let url = '/notice/view.do';
				let param = {
					noticeGuid: this.noticeGuid
				};

				ajax(url, param).then(response => {
					if (response.code == 0) {
						this.messageDetailObj = response.data;
					} else {
						this.$message({
							message: response.desc,
							type: 'warning'
						});
					};				
				});					
			},
		},
		mounted() {
			this.noticeGuid = this.$route.query.noticeGuid;
			let type = this.$route.query.type;
			if (type == 'all') {
				this.name = '全部消息';
				this.backPath = '/allMessage';
			} else if (type == 'unread') {
				this.name = '未读消息';
				this.backPath = '/unreadMessage';
			} else {
				this.name = '已读消息';
				this.backPath = '/readedMessage';
			};
			this.loadDetailData();
		},
	}
</script>

<style scoped lang="scss">	

</style>


// WEBPACK FOOTER //
// MessageDetail.vue?4d0177c8